export function isInTextInput(event: KeyboardEvent) {
  const activeElement = document.activeElement;
  if (!activeElement) return false;
  if (!(activeElement instanceof HTMLElement)) return false;
  if (activeElement.tagName === "TEXTAREA") return true;

  return (
    (event.target instanceof HTMLElement &&
      event.target.classList.contains("ProseMirror")) ||
    (activeElement instanceof HTMLElement &&
      activeElement?.isContentEditable === true &&
      activeElement?.dataset?.useAppUndo != "true")
  );
}

export function isInInput(event: KeyboardEvent) {
  const activeElement = document.activeElement;
  if (!activeElement) return false;
  if (!(activeElement instanceof HTMLElement)) return false;
  if (activeElement.tagName === "INPUT") return true;

  if (activeElement.contentEditable === "true") return true;

  return isInTextInput(event);
}

/**
 * Focuses the next element.
 */
export function focusNextElement() {
  // add all elements we want to include in our selection
  const focussableElementsQuery =
    'a:not([disabled]), [contenteditable="true"], button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
  
  const focussable = Array.prototype.filter.call(
    document.documentElement.querySelectorAll(focussableElementsQuery),
    function (element) {
      //check for visibility while always include the current activeElement
      return (
        element.offsetWidth > 0 ||
        element.offsetHeight > 0 ||
        element === document.activeElement
      );
    }
  );

  const index = focussable.indexOf(document.activeElement);
  if (index > -1) {
    const nextElement = focussable[index + 1] || focussable[0];
    nextElement.focus();
  }
}
